import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFlipHorizontally12 from './IconFlipHorizontally12';
import IconFlipHorizontally16 from './IconFlipHorizontally16';
import IconFlipHorizontally20 from './IconFlipHorizontally20';
import IconFlipHorizontally24 from './IconFlipHorizontally24';
import IconFlipHorizontally32 from './IconFlipHorizontally32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFlipHorizontally = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFlipHorizontally12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFlipHorizontally16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFlipHorizontally20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFlipHorizontally24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFlipHorizontally32 {...props} />}
        </span>
    );
};
IconFlipHorizontally.displayName = 'FondueIconFlipHorizontally';

export default memo(IconFlipHorizontally);
